import React, { Children } from 'react';
import { motion } from 'framer-motion';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
export function ChallengesSection() {
  const scrollToForm = () => {
    const formElement = document.getElementById('lead-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-20 px-4 bg-white" data-id="element-459">
      <div className="max-w-6xl mx-auto" data-id="element-460">
        <div className="text-center mb-12" data-id="element-461">
          <h2 className="text-3xl sm:text-4xl font-black text-[#0f1f3d] mb-4" data-id="element-462">
            Is your child facing these challenges?
          </h2>
          <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-6" data-id="element-463"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-464">
            In just 2 weeks, you'll see a noticeable change. Your child will
            start listening better, focusing longer, and showing more
            confidence. Parents consistently tell us they wish they'd started
            sooner.
          </p>
        </div>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-465">
          {[{
          title: 'Struggling with Focus?',
          desc: 'Difficulty paying attention at school or following directions at home.'
        }, {
          title: 'Low Confidence?',
          desc: 'Shying away from challenges or hesitant to speak up in groups.'
        }, {
          title: 'Too Much Screen Time?',
          desc: 'Spending hours on tablets instead of moving and interacting.'
        }].map((item, idx) => <motion.div key={idx} variants={fadeIn} className="bg-gray-50 p-6 rounded-xl border-2 border-[#a3d977]/20 shadow-sm hover:border-[#a3d977]/40 transition-colors" data-id="element-466">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mb-4 border-2 border-[#a3d977]/30" data-id="element-467">
                <span className="text-red-600 text-xl font-bold" data-id="element-468">?</span>
              </div>
              <h3 className="text-lg font-bold text-[#0f1f3d] mb-2" data-id="element-469">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-470">
                {item.desc}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-center" data-id="element-471">
          <a onClick={scrollToForm} className="inline-block px-10 py-5 bg-[#dc2626] text-white text-xl font-black rounded-lg shadow-2xl hover:bg-red-700 transition-all hover:scale-105 border-2 border-[#a3d977]/30 cursor-pointer" data-id="element-472">
            2 Week Trial Only $29
          </a>
          <p className="mt-4 text-gray-600 text-sm" data-id="element-473">
            No long-term commitment • Official uniform included • Start this
            week
          </p>
        </motion.div>
      </div>
    </section>;
}